/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AssignTermAliases {
  CHECKBOX_0 = 'checkbox-0',
  FETCH_TERM = 'fetch-term',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_NR_SEQ = 'field-nrSeq',
  FIELD_TYPE = 'field-type',
  FORM_TERM = 'form-term',
  HPMS_TEXT_HTML_TERM = 'hpms-text-html-term',
  PANEL_TERM = 'panel-term',
  TEXT_NR_SEQ = 'text-nrSeq',
  TEXT_TYPE = 'text-type',
  TOAST_NOTIFICATION_TERM = 'toast-notification-term',
}
export { AssignTermAliases };
